module.exports = __webpack_public_path__ + "static/img/ARAP16P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAP16P_1.png
// module id = gSQJ
// module chunks = 0